var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowthSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_1427_15864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.53125 17.2656C4.94656 17.2656 2.84375 15.1628 2.84375 12.5781C2.84375 9.99344 4.94656 7.89062 7.53125 7.89062C10.1159 7.89062 12.2188 9.99344 12.2188 12.5781C12.2188 15.1628 10.1159 17.2656 7.53125 17.2656Z",
    fill: "#2A3142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.9375 14.1406C21.3528 14.1406 19.25 12.0378 19.25 9.45312C19.25 6.86844 21.3528 4.76562 23.9375 4.76562C26.5222 4.76562 28.625 6.86844 28.625 9.45312C28.625 12.0378 26.5222 14.1406 23.9375 14.1406Z",
    fill: "#2A3142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.3281 12.5781H34.6406C33.9934 12.5781 33.4688 13.1028 33.4688 13.75C33.4688 14.3972 33.9934 14.9219 34.6406 14.9219H36.499L24.4844 26.9365L21.4067 23.8588C20.9491 23.4013 20.2071 23.4013 19.7495 23.8588L10.7177 32.8906H1.67188C1.02469 32.8906 0.5 33.4153 0.5 34.0625C0.5 34.7097 1.02469 35.2344 1.67188 35.2344H11.2031C11.514 35.2344 11.812 35.1109 12.0317 34.8911L20.5781 26.3448L23.6558 29.4224C24.1134 29.88 24.8554 29.88 25.313 29.4224L38.1562 16.5791V18.4375C38.1562 19.0847 38.6809 19.6094 39.3281 19.6094C39.9753 19.6094 40.5 19.0847 40.5 18.4375V13.75C40.5 13.1028 39.9753 12.5781 39.3281 12.5781Z",
    fill: "#2A3142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.8222 15.3108C26.7084 16.0518 25.3727 16.4844 23.9375 16.4844C22.5024 16.4844 21.1666 16.0519 20.0528 15.3108C18.1566 16.5702 16.9062 18.7249 16.9062 21.1719V23.3876L18.0923 22.2016C18.7562 21.5376 19.6391 21.1719 20.5781 21.1719C21.5171 21.1719 22.4 21.5376 23.064 22.2015L24.4844 23.6219L30.1773 17.9288C29.6256 16.8694 28.8119 15.9682 27.8222 15.3108Z",
    fill: "#2A3142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.64656 18.4358C1.75031 19.6952 0.5 21.8499 0.5 24.2969V30.5469H9.74687L14.5625 25.7313V24.2969C14.5625 21.8499 13.3122 19.6952 11.4159 18.4358C10.3022 19.1769 8.96633 19.6094 7.53125 19.6094C6.09617 19.6094 4.76031 19.1769 3.64656 18.4358Z",
    fill: "#2A3142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1427_15864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthSvg);
export default __webpack_public_path__ + "static/media/GrowthSvg.2cac618a1fca9d0d86d24139a24b23b7.svg";
export { ForwardRef as ReactComponent };